import { ErrorLog } from "../Utils/Models";
import { CandyPopdProtocol } from "../../../../../../Common/CandyApiClient/Types/ErrorLog/CandyPopdProtocol";
import { AttachmentErrorLog } from "../../../../../../Common/CandyApiClient/Types/ErrorLog/AttachmentErrorLog";

export enum ErrorLogActionsType {
    UpdateModelState = "UpdateModelState",
    requestErrorlog = "REQUEST_ERROR_LOG",
    receivedErrorLog = "RECEIVED_ERROR_LOG",
    requestFailed = "REQUEST_FAILED",
    requestExpertErrorlog = "REQUEST_EXPERT_ERROR_LOG",
    receivedExpertErrorLog = "RECEIVED_EXPERT_ERROR_LOG",
    requestExpertErrorLogFailed = "REQUEST_EXPERT_ERROR_LOG_FAILED",
    requestPopdProtocol = "REQUEST_POPD_PROTOCOL",
    receivedPopdProtocol = "RECEIVED_POPD_PROTOCOL",
    requestPopdProtocolFailed = "REQUEST_POPD_PROTOCOL_FAILED",
    setAttachmentErrors = "SET_ATTACHMENT_ERRORS",
    clearAttachmentErrors = "CLEAR_ATTACHMENT_ERRORS",
}

export type ErrorLogAction =
    | {
          type: ErrorLogActionsType.UpdateModelState;
          payload: {
              modelChanged: boolean;
          };
      }
    | {
          type: ErrorLogActionsType.requestErrorlog;
      }
    | {
          type: ErrorLogActionsType.receivedErrorLog;
          payload: ErrorLog;
      }
    | {
          type: ErrorLogActionsType.requestFailed;
      }
    | {
          type: ErrorLogActionsType.requestExpertErrorlog;
      }
    | {
          type: ErrorLogActionsType.receivedExpertErrorLog;
          payload: ErrorLog;
      }
    | {
          type: ErrorLogActionsType.requestExpertErrorLogFailed;
      }
    | {
          type: ErrorLogActionsType.requestPopdProtocol;
      }
    | {
          type: ErrorLogActionsType.receivedPopdProtocol;
          payload: CandyPopdProtocol;
      }
    | {
          type: ErrorLogActionsType.requestPopdProtocolFailed;
      }
    | {
          type: ErrorLogActionsType.setAttachmentErrors;
          payload: AttachmentErrorLog;
      }
    | {
          type: ErrorLogActionsType.clearAttachmentErrors;
      };
